import axios from 'axios';
import app from './main';

axios.defaults.withCredentials = true;

const api = axios.create({
    baseURL: 'https://staging.api.talentalt.com',
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(config => {
    app.$Progress.start(); // for every request start the progress
    return config;
});

api.interceptors.response.use(response => {
    app.$Progress.finish(); // finish when a response is received
    return response;
});

export default api;
